<template>
  <div class="container page">
    <van-nav-bar :title="$t('withdraw.add_crypto_address')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="main-box">
      <div class="label">{{$t("withdraw.add_crypto_tip")}}</div>
      <van-cell-group>
        <van-field v-model="crypto_type" :label="$t('withdraw.coin_type')" readonly :placeholder="$t('withdraw.coin_type')" @click="showSelectCoinType()"/>
        <van-field v-model="network" :label="$t('withdraw.network_type')" readonly :placeholder="$t('withdraw.select_network')" @click="showSelectNetwork()"/>
        <van-field v-model="address" :label="$t('withdraw.wallet_address')" :placeholder="$t('withdraw.wallet_address_tip')" />
      </van-cell-group>
      <p>{{$t("withdraw.crypto_warn")}}</p>
    </div>
    <van-button class="bindCard" type="default" @click="bindCryptoAddress()">{{$t("common.confirm")}}</van-button>

    <!-- 币种选择器 -->
    <van-popup v-model="showCoinTypePicker" round position="bottom" :style="{ height: '35%' }">
      <van-picker
          show-toolbar
          :columns="coinTypes"
          :confirm-button-text="$t('common.confirm')"
          :cancel-button-text="$t('common.cancel')"
          @confirm="onCoinTypeConfirm"
          @cancel="onCoinTypeCancel"
      />
    </van-popup>

    <!-- 网络选择器 -->
    <van-popup v-model="showNetworkPicker" round position="bottom" :style="{ height: '35%' }">
      <van-picker
          show-toolbar
          :columns="networks"
          :confirm-button-text="$t('common.confirm')"
          :cancel-button-text="$t('common.cancel')"
          @confirm="onNetworkConfirm"
          @cancel="onNetworkCancel"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      coinTypes: [
        { text: 'USDC', value: 'USDC' },
        { text: 'BTC', value: 'BTC' },
        { text: 'ETH', value: 'ETH' }
      ],
      networkConfig: {
        'USDC': [
          { text: 'ERC20', value: 'ERC20' },
          { text: 'TRC20', value: 'TRC20' },
          { text: 'Solana', value: 'Solana' },
          { text: 'Polygon', value: 'Polygon' },
          { text: 'Arbitrum', value: 'Arbitrum' }
        ],
        'BTC': [
          { text: 'Bitcoin', value: 'Bitcoin' },
          { text: 'BTC (SegWit)', value: 'SegWit' },
          { text: 'Lightning Network', value: 'Lightning' }
        ],
        'ETH': [
          { text: 'ERC20', value: 'ERC20' },
          { text: 'Arbitrum', value: 'Arbitrum' },
          { text: 'Optimism', value: 'Optimism' },
          { text: 'Polygon', value: 'Polygon' },
          { text: 'zkSync', value: 'zkSync' }
        ]
      },
      networks: [],
      showCoinTypePicker: false,
      showNetworkPicker: false,
      network: "",
      address: "",
      crypto_type: ""
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    bindCryptoAddress(){
      if(!this.crypto_type){
        this.$toast.fail(this.$t("withdraw.coin_type"));
        return;
      }
      if(!this.network){
        this.$toast.fail(this.$t("withdraw.select_network"));
        return;
      }
      if(!this.address){
        this.$toast.fail(this.$t("withdraw.wallet_address_tip"));
        return;
      }
      this.$http({
        method: 'post',
        data: {
          address: this.address,
          crypto_type: this.crypto_type,
          network: this.network
        },
        url: 'user_set_crypto_address'
      }).then(res => {
        if(res.code === 200){
          this.$toast(res.msg);
          this.$router.push({path: '/Withdraw'});
        } else if(res.code === 401){
          this.$toast(res.msg);
        }
      });
    },
    showSelectCoinType(){
      this.showCoinTypePicker = true;
    },
    showSelectNetwork(){
      if(!this.crypto_type){
        this.$toast.fail(this.$t("withdraw.coin_type"));
        return;
      }
      this.showNetworkPicker = true;
    },
    onCoinTypeConfirm(value) {
      this.crypto_type = value.text;
      this.networks = this.networkConfig[value.value] || [];
      this.network = "";
      this.showCoinTypePicker = false;
    },
    onCoinTypeCancel() {
      this.showCoinTypePicker = false;
    },
    onNetworkConfirm(value) {
      this.network = value.text;
      this.showNetworkPicker = false;
    },
    onNetworkCancel() {
      this.showNetworkPicker = false;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path: '/Login'});
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 32px;
  line-height: 80px;
}
.van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.main-box {
  background: #fff;
}
.main-box .label {
  padding: 20px;
  font-size: 35px;
  color: #797878;
}
::v-deep .van-picker__toolbar {
  height: 100px;
}
::v-deep .van-picker__cancel, ::v-deep .van-picker__confirm {
  padding: 0 40px;
  font-size: 32px;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
.main-box p {
  padding: 0 20px;
  font-size: 30px;
  color: #ee0a24;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(90deg, #e6c3a1, #7e5678);
}
</style>
